module.exports = __webpack_public_path__ + "static/media/2.84e8c5d3.jpg";